/* with love from shopstory */
'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function assertDefined(value, message) {
  if (value === undefined) {
    throw new Error(message ?? "Value is undefined");
  }
  return value;
}

exports.assertDefined = assertDefined;
